<template lang="pug">
  AreaTemplate(
    :title="title"
    :subTitle="subTitle"
    :message="message"
    url="https://imasugu-kanteishi.com/"
    image="img/logo_kanteishi.png"
    :comment="comment"
    button_label="イマスグ不動産鑑定士の<br>サービスサイトへ"
  )
</template>

<script lang="js">
import AreaTemplate from '@/components/step03/AreaTemplate.vue';

export default {
  components: {
    AreaTemplate,
  },
  props: {
    priceData: {
      type: Object,
      default: {},
    },
  },
  computed: {
    title() {
      if (this.priceData.style === 1) {
        return '所有する不動産価値を正しく知らないと相続税で”損”をしてしまう可能性も！？';
      }
      return '所有する不動産価値を正しく知らないと相続税で”損”をする可能性も！？';
    },
    subTitle() {
      if (this.priceData.style === 1) {
        return '不動産の評価額を正しく把握することが相続税対策に繋がります。';
      }
      return '不動産の評価額を正しく把握することをオススメします。';
    },
    message() {
      if (this.priceData.style === 1) {
        return '土地は路線価評価により行うのが基本ですが、実際は土地の形状、規模、道路との高低差など、土地の個別性が強い場合、評価額が下がったケースもある為、不動産鑑定士による適正な評価を強くオススメします。';
      }
      return '土地の個別性が強い物件、空室率が高い収益物件、郊外で需要が極めて低い物件など、取引に難があるような物件の場合、評価額が下がる可能性があるので、不動産鑑定士による適正な評価を強くオススメします。';
    },
    comment() {
      return '「イマスグ不動産鑑定士」は、オンラインで不動産鑑定を行うことができるサービスです。中でもメインサービスの【ポチッと鑑定】では、これまで高額だった鑑定を、安価でスピーディに提供することが出来て、不動産オーナーから好評を得ています。';
    },
  },
  mounted() {
    this.$emit('area_data', {
      title: this.title,
      subTitle: this.subTitle,
      message: this.message,
      comment: this.comment,
    });
  },
};
</script>